import type { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

/**
 * Сброс слайсов конкретной сборки при выходе. authSlice.logout сбрасывает
 * только авторизацию, остальное регистрирует store сборки — так authSlice не
 * тянет за собой слайсы, которых в сборке нет.
 */
type CleanupDispatch = ThunkDispatch<unknown, unknown, UnknownAction>;
type LogoutCleanup = (dispatch: CleanupDispatch, userId: string | number | undefined) => void;

const cleanups: LogoutCleanup[] = [];

export function registerLogoutCleanup(cleanup: LogoutCleanup): void {
  cleanups.push(cleanup);
}

export function runLogoutCleanups(dispatch: CleanupDispatch, userId: string | number | undefined): void {
  cleanups.forEach((cleanup) => cleanup(dispatch, userId));
}
